import { TextField } from '@mui/material';
import Field from '../../../form/fields/Field';


export default function QuestionnaireField ({field, formik, autoFocus = false}) {

    const label = field.label

    switch (field.type) {

        case "radio":
            var options = Object.keys(field.options).map(optionValue => {
                return {value: optionValue, label: field.options[optionValue]}
            }) 
            return (
                <Field.Radio 
                    label={field.label}
                    helpText={field.helpText}
                    name={field.name}
                    value={formik.values[field.name]}
                    warning={formik.errors[field.name]}
                    options={options}
                    onChange={formik.handleChange} />
            )

        case "radio":
            var options = Object.keys(field.options).map(optionValue => {
                return {value: optionValue, label: field.options[optionValue]}
            }) 
            return (
                <Field.Select 
                    label={field.label}
                    helpText={field.helpText}
                    name={field.name}
                    value={formik.values[field.name]}
                    warning={formik.errors[field.name]}
                    options={options}
                    onChange={formik.handleChange} />
            )

        case "date":
            return (
                <Field.Date
                    label={field.label}
                    helpText={field.helpText}
                    name={field.name}
                    value={formik.values[field.name]}
                    warning={formik.errors[field.name]}
                    onChange={(e) => {
                        formik.setFieldValue(field.name, e.target.value)
                    }} />
            )

        case "div":
            if (label === null || label.includes("{")) {
                return <></>
            }
            return <div dangerouslySetInnerHTML={{__html: label}}></div>
  
        case "checkbox":
            return (
                <div className="form-field field-checkbox">
                    <label>
                        <input
                            name={field.name}
                            checked={formik.values[field.name] === "true"}
                            type="checkbox"
                            onChange={(e) => {
                                formik.setFieldValue(field.name, formik.values[field.name] === "true" ? "false" : "true")
                            }}
                        />
                        <span className="field-checkbox-label-content">{label}</span>
                    </label>

                    {field.helpText ? <span className="help-text">{field.helpText}</span> : null}
                </div>
            )

        case "number":
        case "text-area":
        default:

            var len = formik.values[field.name]?.length

            return (
                <div className="form-field" style={{display: "grid", gap: "2px"}}>
                    <TextField
                        name={field.name}
                        value={formik.values[field.name]}
                        label={label}
                        type={field.type === "number" ? "number" : "text"}
                        variant={field.type === "text-area" ? "filled" : "standard"}
                        multiline={field.type === "text-area"}
                        rows={field.type === "text-area" ? 4 : 1}
                        autoFocus={autoFocus}
                        error={formik.submitCount && formik.errors[field.name] ? formik.errors[field.name] : false}
                        onChange={(e) => {
                            // Remove any bullet points
                            if (e.target.value?.includes("•")) {
                                e.target.value = e.target.value.replaceAll("•", "")
                            }
                            formik.handleChange(e)
                        }}/>

                    {field.type === "text-area" ? <span className="help-text">{len ? len : 0} characters</span> : null}

                    {field.helpText ? <span className="help-text">{field.helpText}</span> : null}
                </div>
            )
    }
}